import React, { useEffect } from "react";
import CardNew from "../CardNews/CardNew";
import { useDispatch, useSelector } from "react-redux";
import { SERVICE, LIMIT } from "constants/global";
import { Pagination } from "components";
import { getNews } from "features/News/newSlice";
import { scroolElement } from "utils/common";
import ErrorDB from "components/ErrorDB";

const TabNews = ({ isActive, currentPageNews, setCurrentPageNews }) => {
  const dispatch = useDispatch();

  const { news, isInLine } = useSelector((state) => state.news);

  useEffect(() => {
    dispatch(
      getNews({
        limit: LIMIT,
        service: SERVICE,
        currentPage: currentPageNews,
      })
    );
  }, []);

  const handleLoadPage = (currentPageNews) => {
    setCurrentPageNews(currentPageNews);
    dispatch(
      getNews({
        limit: LIMIT,
        service: SERVICE,
        currentPage: currentPageNews,
      })
    );
    scroolElement(".tabs-content-news", 200);
  };

  return (
    isActive && (
      <div className="tab-panel-news active">
        <div className="border-color-black border-form-hidden p-1 p-md-0">
          <div className="bg-grey py-1 py-md-2 px-2">
            <div className="title color-title-new text-start text-md-center py-2">
              ニュース
            </div>
          </div>
          { isInLine ? <ErrorDB/> :
          <div>
            {news &&
              news?.data.map((item) => (
                <CardNew key={item.id} item={item} type={2} />
              ))}
          </div>}
        </div>

        {news?.last_page > 1 && (
          <Pagination
            pages={news?.last_page}
            currentPage={news?.current_page}
            handle={handleLoadPage}
          />
        )}
      </div>
    )
  );
};

export default TabNews;
